import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export class Carousel extends Component {
    constructor(props) {
        super(props);

        let { width, height } = props;
        let size = { width: width, height: height, amount: 10 };

        let dynamicStyles = {
            frame: { width: `${size.width}px`, height: `${size.height}px` },
            carousel: { width: `calc(${size.width}px * ${size.amount})` },
            carouselImg: { transform: `translate(calc(-${size.width}px * 3))`, width: `${size.width}px`, height: `${size.height}px`, opacity: 0.2 }
        }

        this.state = {
            size: size,
            styles: dynamicStyles,
            index: 0,
            displayIndex: 3,
            amount: 0,
            currTransl: [],
            translationComplete: true
        };
    }

    componentDidMount() {
        let am = 10;
        let { width, height } = this.props;

        let size = { width: width, height: height, amount: am };

        let dynamicStyles = {
            frame: { width: `${size.width}px`, height: `${size.height}px` },
            carousel: { width: `calc(${size.width}px * ${size.amount})` },
            carouselImg: { transform: `translate(calc(-${size.width}px * 3))`, width: `${size.width}px`, height: `${size.height}px`, opacity: 0.2 }
        }

        this.setState({
            amount: am,
            size: size,
            dynamicStyles: dynamicStyles
        });

        let outerIndex = 0;
        //this.setState({ displayIndex: outerIndex === 0 ? am : outerIndex });

        let { currTransl } = this.state;

        for (let i = 0; i < am; i++) {
            currTransl[i] = -width * 3;
            ReactDOM.findDOMNode(this).getElementsByClassName('carousel-img')[i].addEventListener("transitionend", this.transitionCompleted.bind(this), true);
            ReactDOM.findDOMNode(this).getElementsByClassName('carousel-img')[i].addEventListener("webkitTransitionEnd", this.transitionCompleted.bind(this), true);
            ReactDOM.findDOMNode(this).getElementsByClassName('carousel-img')[i].addEventListener("oTransitionEnd", this.transitionCompleted.bind(this), true);
            ReactDOM.findDOMNode(this).getElementsByClassName('carousel-img')[i].addEventListener("MSTransitionEnd", this.transitionCompleted.bind(this), true);
        }
        this.setState({ currTransl: currTransl });

        let img = ReactDOM.findDOMNode(this).getElementsByClassName("carousel-img")[3];
        img.style.opacity = 1;
    }

    transitionCompleted() {
        this.setState({
            translationComplete: true
        });
    }

    left() {
        if (this.state.translationComplete === true) {
            this.setState({ translationComplete: false });

            let { currTransl, index: idx, size: { width }, displayIndex } = this.state;
            idx--;

            if (idx === -1) {
                idx = this.state.amount - 1;
            }
            this.setState({ index: idx });

            let outerIndex = (idx) % this.state.amount;

            displayIndex--;
            displayIndex = displayIndex < 0 ? this.state.amount + displayIndex : displayIndex;
            this.setState({ displayIndex: displayIndex });

            for (let i = 0; i < this.state.amount; i++) {
                let img = ReactDOM.findDOMNode(this).getElementsByClassName("carousel-img")[i];
                if (displayIndex === i) {
                    img.style.opacity = '1';
                } else {
                    img.style.opacity = '.2';
                }
                img.style.transform = `translate(${currTransl[i] + width}px)`;
                currTransl[i] = currTransl[i] + width;
            }

            let outerImg = ReactDOM.findDOMNode(this).getElementsByClassName("carousel-img")[outerIndex];
            outerImg.style.transform = `translate(${currTransl[outerIndex] - width * (this.state.amount)}px)`;
            outerImg.style.opacity = '0';
            currTransl[outerIndex] = currTransl[outerIndex] - width * (this.state.amount);

            this.setState({ currTransl: currTransl });
        }
    }

    right() {
        if (this.state.translationComplete === true) {
            this.setState({ translationComplete: false });

            let { currTransl, index: idx, size: { width }, displayIndex } = this.state;

            idx = idx + 1;
            this.setState({ index: idx });

            let outerIndex = (idx - 1) % this.state.amount;
            // this.setState({ displayIndex: outerIndex + 1 });

            displayIndex++;
            displayIndex = displayIndex >= this.state.amount ? 0 : displayIndex;
            console.log(displayIndex);
            this.setState({ displayIndex: displayIndex });

            for (let i = 0; i < this.state.amount; i++) {
                let img = ReactDOM.findDOMNode(this).getElementsByClassName("carousel-img")[i];
                if (i === displayIndex) {
                    img.style.opacity = '1';
                } else {
                    img.style.opacity = '.2';
                }
                img.style.transform = `translate(${currTransl[i] - width}px)`;
                currTransl[i] = currTransl[i] - width;
            }

            var outerImg = ReactDOM.findDOMNode(this).getElementsByClassName("carousel-img")[outerIndex];
            outerImg.style.transform = `translate(${currTransl[outerIndex] + width * (this.state.amount)}px)`;
            outerImg.style.opacity = '0';
            currTransl[outerIndex] = currTransl[outerIndex] + width * (this.state.amount);

            this.setState({ currTransl: currTransl });
        }
    }

    render() {
        const { styles: { frame: frameStyle, carousel: carouselStyle, carouselImg: imgStyle } } = this.state;

        return (
            <div>
                <div className="frame" style={frameStyle}>
                    <div id={this.props.id} style={carouselStyle} className="animate carousel">
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-8.jpg" alt="8" title="8" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-9.jpg" alt="9" title="9" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-10.jpg" alt="10" title="10" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-1.jpg" alt="1" title="1" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-2.jpg" alt="2" title="2" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-3.jpg" alt="3" title="3" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-4.jpg" alt="4" title="4" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-5.jpg" alt="5" title="5" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-6.jpg" alt="6" title="6" />
                        <img style={imgStyle} className="animate carousel-img" src="./images/slides/slide-7.jpg" alt="7" title="7" />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/AppSlideshow/Carousel.jsx